import { getApiBaseUrl } from "@/config/runtime";
import type { CompanyContextPreview, CompanyProfile, CompanyProfileUpdate, DataResponse } from "@/types";
import { api, getHeaders } from "../api";

export const companyProfileService = {
  get: () => api.get<DataResponse<CompanyProfile | null>>("/admin/company"),

  upsert: (data: CompanyProfileUpdate) => api.put<DataResponse<CompanyProfile>>("/admin/company", data),

  previewContext: () => api.get<DataResponse<CompanyContextPreview>>("/admin/company/context-preview"),

  uploadLogo: async (file: File): Promise<DataResponse<{ logo_url: string }>> => {
    const headers = await getHeaders();
    headers.delete("Content-Type"); // Let browser set multipart boundary
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${getApiBaseUrl()}/admin/company/logo`, {
      method: "POST",
      headers,
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || response.statusText);
    }

    return response.json();
  },
};
